import { chakra, Flex, Text, Image } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import ZhDoc from "./doc/ZhDoc";
import ZhTWDoc from "./doc/ZhTWDoc";
import EnDoc from "./doc/EnDoc";
import { useAppSelector } from "@/state/hooks";
import { useEffect, useRef } from "react";
import { useMedia } from "@/hooks/useMedia";

const Wrap = chakra(Flex, {
  baseStyle: {
    boxSize: "border-box",
    flexDirection: "column",
    height: "408px",
    overflowY: "scroll",
    backgroundColor: "#FAFAFA",
    boder: "1px solid rgba(32, 26, 85, 0.05)",
    borderRadius: "14px",
  },
});

const CheckWrap = chakra(Flex, {
  baseStyle: {
    mt: "20px",
    "&.disabled": {
      cursor: "not-allowed",
    },
  },
});
const Agreement = ({
  setAgreementDisabled,
  agreementDisabled,
  setCheckedAgreement,
  checkedAgreement,
}) => {
  const { t } = useI18n();
  const lang = useAppSelector((state) => state.user.language);
  const refDOM = useRef(null);
  const { isMobile } = useMedia();

  useEffect(() => {
    if (refDOM) {
      const _dom = refDOM.current;
      _dom.addEventListener("scroll", () => {
        // 获取容器的滚动高度和内容总高度
        const scrollTop = _dom.scrollTop;
        const scrollHeight = _dom.scrollHeight;
        const clientHeight = _dom.clientHeight;

        // 检查是否滚动到底部
        if (scrollTop + clientHeight >= scrollHeight) {
          setAgreementDisabled(false);
        }
      });
    }
  }, [refDOM]);

  return (
    <>
      <Wrap
        id="agreement-scroll-container"
        ref={refDOM}
        p={isMobile ? "20px 10px" : "40px 30px"}
      >
        <Text
          fontSize={18}
          color={"#010313"}
          fontWeight={600}
          margin={"0 auto"}
        >
          {t("xJSUCPiMmZcheTPhmSp")}
        </Text>
        {lang === "zh" && <ZhDoc />}
        {lang === "en" && <EnDoc />}
        {lang === "tw" && <ZhTWDoc />}
      </Wrap>
      <CheckWrap className={agreementDisabled ? "disabled" : ""}>
        <Image
          mt={"2px"}
          src={
            checkedAgreement
              ? "../../wwwsite/images/kyc/checked.svg"
              : "../../wwwsite/images/kyc/no_check.svg"
          }
          width={"18px"}
          height={"18px"}
          style={{
            cursor: "pointer",
            marginRight: "8px",
          }}
          onClick={() => {
            if (!agreementDisabled) {
              setCheckedAgreement(!checkedAgreement);
            }
          }}
        />
        <Text
          color={agreementDisabled ? "#7B7C8F" : "#010313"}
          fontSize={"14px"}
        >
          {t("URaqlpEnAJFNwqZpf")}
        </Text>
      </CheckWrap>
    </>
  );
};

export default Agreement;
